package tta.destinigo.talktoastro.shared.data

import kotlinx.serialization.Serializable

@Serializable
data class RequestCategory(
    val id: Int ,
    val name: String? = null,
    val image: String? = null,
    val image_url: String? = null,
    val subcategories: List<SubCategoriesModel>? = null
)
